
import {SmartTipWidget} from "./smart-tip-widget";
import {TemplateEngine} from "../lib/template-engine";
import {GiftManager} from "../component/gift";
import {JoinedRoomData} from "../chatserver/sx-server";
import {Translator} from "../utils/translator";

export class SpecialGiftPanel
{
	private smartTips : SmartTipWidget;
	private smartToysEnabled : boolean;
	public onSmartZzzSend : Function;
	private page = 0;
	private giftsOnOnePage = 0;

	constructor(
		private $root : JQuery,
		private templateEngine : TemplateEngine,
		private translator : Translator,
		private giftManager : GiftManager,
	)
	{
		this.$root.on("click", ".nav.prev", () => this.scroll(-1));
		this.$root.on("click", ".nav.next", () => this.scroll(1));

		this.smartTips = new SmartTipWidget(
			this.$root.find(".sxccp-smarttips-wrapper"),
			giftManager,
			this.translator,
			(price : number) => {
				this.onSmartZzzSend(price);
			}
		);

		this.enableSmartToys(false);
	}


	enableSmartToys(enable = true)
	{
		this.smartToysEnabled = enable;
		this.scroll(0);
	}

	resize(w)
	{
		const giftW = 129;
		const minSpacing = 5;
		const availableW = w ? w : this.$root.width();
		this.giftsOnOnePage = Math.floor(availableW / (giftW + minSpacing));

		// Let's distribute gifts
		this.$root.find(".sxccp-smarttips-wrapper").css({
			"width" : availableW
		});

		this.$root.find(".gift-list").css({
			"width" : availableW
		});

		this.smartTips.resize(w);
		this.scroll(0);
	}

	scroll(d)
	{
		let $giftList = this.$root.find(".gift-list");
		let list = this.smartToysEnabled
			? this.giftManager.getSmartToysGifts()
			: this.giftManager.getSuggestions();

		let giftCount = list.length;

		let maxPages = Math.ceil(giftCount / this.giftsOnOnePage);

		if (this.smartTips) {
			maxPages++;
		}

		this.page += d;
		if (this.page > maxPages - 1) this.page = 0;
		if (this.page < 0) this.page = maxPages - 1;

		if (this.page === 0 && this.smartToysEnabled) {
			this.$root.find(".sxccp-smarttips-wrapper").show();
			$giftList.hide();
		} else {
			this.$root.find(".sxccp-smarttips-wrapper").hide();
			$giftList.show().empty();

			let p = this.smartToysEnabled ? this.page - 1 : this.page;

			let first = p * this.giftsOnOnePage;
			let last = (p + 1) * this.giftsOnOnePage - 1;

			if (last > list.length - 1) {
				last = list.length - 1;
				first = list.length - this.giftsOnOnePage;
			}

			for (let i=first; i<=last; i++) {
				let $item = this.templateEngine.render(
					"extragiftpanel-gift",
					{
						gift: list[i],
						extraClass: this.smartToysEnabled ? "smarttoy" : "suggestion"
					}
				);
				if ("priceCat" in list[i]) $item.attr("data-pcat", list[i]["priceCat"]);
				$giftList.append($item);
			}
		}

		let offset = this.page * this.$root.width();
		$(".scrollable").scrollLeft(offset);
	}

	/**
	 * Places this component to the specified coordinates with the specified size
	 */
	public place(x : number, y : number, w : number, h : number) : void
	{
		this.$root.css("display", "block");
		this.$root.css({
			top: y,
			left: x,
			width: w,
			height: h
		});

		this.resize(w);
	}

	/**
	 * Clears placement css from this component
	 */
	public clearPlace() : void
	{
		this.$root.css("display", "none");
		this.$root.css({
			top: "",
			left: "",
			bottom: "",
			right: "",
			width: "",
			height: ""
		});

		// this.resize();
	}

	public setVisible(visible : boolean)
	{
		this.$root.css({
			"visibility": visible ? "visible" : "hidden"
		});
	}

	public performerChanged(perf : JoinedRoomData)
	{
		if (!perf) {
			this.setVisible(false);
			return;
		}

		const isExternal = isNaN(parseInt(perf.roomid, 10));

		if (isExternal) {
			this.setVisible(false);
			return;
		}

		this.setVisible(true);

		const hasSmartToys = (perf.publicData.toys && !!perf.publicData.toys.default);
		this.enableSmartToys(hasSmartToys);
	}
}
